<template>
  <UIButton
    v-if="buttonTrigger.type === 'form'"
    :variant="buttonVariant || 'primary'"
    :size="buttonSize"
    @click="openFeedback"
    >{{ buttonTitle }}</UIButton
  >
  <UIButton
    v-else-if="buttonTrigger.type === 'doctor_execute'"
    :variant="buttonVariant || 'primary'"
    :size="buttonSize"
    @click="openFormModal"
    >{{ buttonTitle }}</UIButton
  >
  <UIButton
    v-else
    :link="link"
    type="link"
    :size="buttonSize"
    :link-type="
      buttonTrigger.type === 'link' ? '_self' : buttonTrigger.is_target_blank ? '_blank' : '_self'
    "
    :variant="buttonVariant"
    >{{ buttonTitle }}</UIButton
  >

  <COnlineRegistration
    v-if="buttonTrigger.type === 'doctor_execute' && isModalOpen"
    :is-open="isModalOpen"
    :block-id="blockId"
    :slider-media-id="sliderMediaId"
    :tab-id="tabId"
    @onCloseModal="isModalOpen = false"
  />
</template>

<script setup lang="ts">
import type { BlockButtonTrigger } from '~/types/pages';
import { computed, defineAsyncComponent, ref, useSlugTransform } from '#imports';
import UIButton from '~/components/UI/button/UIButton.vue';
import { useFeedbackWidget } from '~/composables/useFeedbackWidget';

const COnlineRegistration = defineAsyncComponent(
  () => import('~/components/blocks/onlineRegistration/COnlineRegistration.vue'),
);

interface Props {
  buttonTitle: string;
  buttonTrigger: BlockButtonTrigger;
  buttonVariant?: 'secondary' | 'primary' | 'white';
  buttonSize?: 'xl' | 'l' | 's';
  blockId?: number;
  sliderMediaId?: number;
  tabId?: number;
}

const props = defineProps<Props>();

const link = computed(() => {
  if (props.buttonTrigger.type === 'link') {
    return { name: 'home', params: { chapters: useSlugTransform(props.buttonTrigger.content) } };
  }

  return props.buttonTrigger.content;
});

const isModalOpen = ref(false);

const { open: openFeedback } = useFeedbackWidget();

const openFormModal = () => {
  isModalOpen.value = true;
};
</script>
